import type { ReactElement, SVGProps } from "react";

export function CashbackOnBanner(
  props: SVGProps<SVGSVGElement>,
): ReactElement {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2891 3.07031L16.2275 3.72461L15.9268 6.74707L17.9199 9L15.9268 11.2529L16.2275 14.2754L13.2891 14.9297L11.7725 17.5254L9 16.3525L6.22754 17.5254L4.71191 14.9297L1.77246 14.2754L2.07422 11.2529L0.0800781 9L2.07422 6.74707L1.77246 3.72461L4.71191 3.07031L6.22754 0.474609L9 1.64746L11.7725 0.474609L13.2891 3.07031ZM11.1729 9.83398C10.801 9.83398 10.4842 9.96342 10.2236 10.2236C9.96317 10.484 9.8331 10.8002 9.83301 11.1719C9.83301 11.5438 9.96336 11.8605 10.2236 12.1211C10.484 12.3815 10.8002 12.5117 11.1719 12.5117C11.5437 12.5117 11.8596 12.3813 12.1201 12.1211C12.3807 11.8607 12.5117 11.5446 12.5117 11.1729C12.5117 10.8011 12.3811 10.4851 12.1211 10.2246C11.8608 9.96413 11.5445 9.83406 11.1729 9.83398ZM5.6709 11.2148L6.96387 12.5068L12.5059 6.96484L11.2139 5.67188L5.6709 11.2148ZM7.00586 5.66699C6.63391 5.66699 6.3172 5.79734 6.05664 6.05762C5.79635 6.31796 5.66602 6.63424 5.66602 7.00586C5.66607 7.37763 5.79652 7.69363 6.05664 7.9541C6.31703 8.21463 6.63313 8.3447 7.00488 8.34473C7.37683 8.34473 7.69355 8.21536 7.9541 7.95508C8.21455 7.69476 8.34464 7.37846 8.34473 7.00684C8.34473 6.63489 8.21438 6.31817 7.9541 6.05762C7.6937 5.79712 7.37762 5.667 7.00586 5.66699Z"
        fill="#128351"
      />
    </svg>
  );
}
